import { Image } from 'models'
import { DropzoneOptions } from 'react-dropzone'
import { GeneralStore, GENERAL_STORE } from 'store'
import { GalleryDropZoneRef } from '../GalleryDropZone'
import { RatingStarsProps } from '../RatingStars'
import { SectionContainerProps } from '../SectionContainer'

export enum EntityInfoPropertyType {
  TEXT,
  TAGS
}

export type EntityInfoProperty = {
  label: string
  type: EntityInfoPropertyType
  value: string
  onChange?: (value: string) => void
}

export type EntityInfoSectionProps = {
  name: string
  setName: (value: string) => void
  mainImage: string
  ratingProps?: RatingStarsProps
  saveChanges?: (images: Image[]) => void
  discardChanges?: () => void
  editMode?: boolean
  onEditModeOn?: () => void
  onEditModeOff?: () => void

  sectionContainerProps?: SectionContainerProps

  dropZoneOptions?: DropzoneOptions

  children?: React.ReactNode
  propertyFields?: EntityInfoProperty[]
  textareaField?: EntityInfoProperty
  images: Image[]
  imagesRef?: GalleryDropZoneRef

  [GENERAL_STORE]?: GeneralStore
}
